module.exports = __webpack_public_path__ + "img/invitados-duo.429c1cfb.svg";